import { Link } from 'react-router-dom';
import SEOHead from '../components/common/SEOHead';

const NotFoundPage = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found"
        description="The page you are looking for does not exist."
        noIndex
      />

      <div className="section-padding">
        <div className="container-max text-center">
          <h1 className="text-6xl font-display font-bold text-gray-900 mb-4">
            404
          </h1>
          <h2 className="text-2xl font-display font-semibold text-gray-700 mb-6">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist.
          </p>
          <Link to="/" className="btn-primary">
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
